(() => {
  const root = document.querySelector('.p10194551767337-page[data-v3-page]');
  if (!root) return;
  const visualCards = root.dataset.v3PurchaseLayout === 'visual_cards';
  let variantPresentation = {};
  if (visualCards) {
    try {
      const config = root.querySelector('[data-v3-variant-presentation]');
      variantPresentation = config ? JSON.parse(config.textContent) : {};
    } catch (_) { /* Commerce remains native when optional presentation is absent. */ }
  }

  const activeTheme = window.Shopify && window.Shopify.theme;
  const previewUrl = new URL(window.location.href);
  const previewThemeIds = previewUrl.searchParams.getAll('preview_theme_id');
  const viewSuffixes = previewUrl.searchParams.getAll('view');
  const activeThemeId = String((activeTheme && activeTheme.id) || '');
  const activeThemeRole = String((activeTheme && activeTheme.role) || '').toLowerCase();
  if (
    previewThemeIds.length === 0
    && viewSuffixes.length === 1
    && viewSuffixes[0] === 'p10194551767337'
    && activeThemeRole === 'unpublished'
    && /^[1-9][0-9]*$/.test(activeThemeId)
  ) {
    previewUrl.searchParams.set('preview_theme_id', activeThemeId);
    window.history.replaceState(window.history.state, '', previewUrl.toString());
  }

  const variantSelects = Array.from(root.querySelectorAll('[data-v3-variant-select]'));
  const variantChoices = Array.from(root.querySelectorAll('[data-variant-choice]'));
  const heroImage = root.querySelector('[data-v3-variant-hero]')
    || root.querySelector('[data-gallery-main] img');
  let variantMedia = {};
  try {
    const mediaConfig = root.querySelector('[data-v3-variant-media]');
    variantMedia = mediaConfig ? JSON.parse(mediaConfig.textContent) : {};
  } catch (_) { /* Keep the authored image when a legacy page has no usable map. */ }
  const authoredHero = heroImage && {
    src: heroImage.dataset.v3DefaultSrc || heroImage.getAttribute('src'),
    srcset: heroImage.dataset.v3DefaultSrcset || heroImage.getAttribute('srcset') || '',
    alt: heroImage.dataset.v3DefaultAlt || heroImage.getAttribute('alt') || '',
  };
  const fallbackHero = variantMedia.fallback || authoredHero;
  const presentationFor = (id) => Object.prototype.hasOwnProperty.call(variantPresentation, id)
    && variantPresentation[id] && typeof variantPresentation[id] === 'object' ? variantPresentation[id] : {};
  if (visualCards) {
    root.querySelectorAll('[data-v3-purchase]').forEach((box, index) => {
      let lastGroup = '';
      box.querySelectorAll('[data-variant-choice]').forEach((choice) => {
        const detail = presentationFor(String(choice.dataset.variantId));
        const description = choice.querySelector('[data-v3-variant-description]');
        if (description) {
          description.textContent = detail.description || '';
          description.id = `p10194551767337-description-${index}-${choice.dataset.variantId}`;
          choice.setAttribute('aria-describedby', description.id);
        }
        if (detail.group && detail.group !== lastGroup) {
          const heading = document.createElement('p');
          heading.className = 'p10194551767337-variant-group-label';
          heading.textContent = detail.group;
          heading.setAttribute('data-v3-variant-group', detail.group);
          choice.before(heading);
        }
        lastGroup = detail.group || '';
      });
      const toggle = box.querySelector('[data-v3-change-style]');
      const panel = box.querySelector('[data-v3-choice-panel]');
      if (toggle && panel) {
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.addEventListener('click', () => {
          panel.hidden = !panel.hidden;
          toggle.setAttribute('aria-expanded', String(!panel.hidden));
          toggle.textContent = panel.hidden ? 'Change style' : 'Hide styles';
          if (!panel.hidden) panel.querySelector('[data-variant-choice][aria-checked="true"]')?.focus({ preventScroll: true });
        });
      }
    });
  }
  const syncConfirmation = () => {
    if (!visualCards) return;
    const select = variantSelects[0];
    const option = select && select.options[select.selectedIndex];
    if (!option) return;
    const id = String(option.value);
    const title = option.dataset.v3OptionTitle || '';
    const price = option.dataset.v3OptionPrice || '';
    const quantity = Number(root.querySelector('[data-v3-quantity-input]')?.value) || 1;
    const cents = Number(option.dataset.v3OptionCents);
    const detail = presentationFor(id);
    const media = (variantMedia.variants && variantMedia.variants[id]) || fallbackHero;
    const thumbnail = variantChoices.find((choice) => String(choice.dataset.variantId) === id)
      ?.querySelector('.p10194551767337-variant-thumbnail');
    // Reuse this exact variant's responsive thumbnail; the hero candidates are larger.
    const confirmationMedia = thumbnail ? {
      src: thumbnail.getAttribute('src'), srcset: thumbnail.getAttribute('srcset') || '',
    } : media;
    let subtotal = price;
    if (quantity !== 1 && Number.isFinite(cents)) {
      try {
        subtotal = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: root.dataset.v3Currency,
        }).format(cents * quantity / 100);
      } catch (_) { subtotal = `${quantity} × ${price}`; }
    }
    root.querySelectorAll('[data-v3-confirmation-title], [data-v3-sticky-title], [data-v3-contents-title]').forEach((node) => { node.textContent = title; });
    root.querySelectorAll('[data-v3-confirmation-detail]').forEach((node) => { node.textContent = detail.description || ''; });
    root.querySelectorAll('[data-v3-confirmation-quantity]').forEach((node) => { node.textContent = `× ${quantity}`; });
    root.querySelectorAll('[data-v3-selection-subtotal]').forEach((node) => { node.textContent = subtotal; });
    root.querySelectorAll('[data-v3-sticky-price]').forEach((node) => { node.textContent = `${quantity} × ${price}`; });
    root.querySelectorAll('[data-v3-selected-contents]').forEach((node) => { node.textContent = detail.included_items || detail.description || ''; });
    root.querySelectorAll('[data-v3-quantity-note]').forEach((node) => {
      node.textContent = detail.quantity_note || '';
      node.hidden = !detail.quantity_note;
    });
    root.querySelectorAll('[data-v3-confirmation-image]').forEach((image) => {
      image.hidden = !confirmationMedia?.src;
      if (confirmationMedia?.src) {
        image.src = confirmationMedia.src;
        if (confirmationMedia.srcset) image.srcset = confirmationMedia.srcset;
        else image.removeAttribute('srcset');
        image.sizes = '80px';
      }
      image.alt = title;
    });
    const stickyButton = root.querySelector('[data-v3-sticky-add]');
    if (stickyButton) stickyButton.disabled = purchasePending || cartUnconfirmed || option.disabled;
  };
  const syncHero = (id) => {
    if (!heroImage) return;
    const media = (variantMedia.variants && variantMedia.variants[id]) || fallbackHero;
    if (!media || !media.src) return;
    heroImage.setAttribute('data-v3-variant-hero', '');
    heroImage.dataset.v3VariantId = id;
    const width = Number(heroImage.getAttribute('width'));
    const height = Number(heroImage.getAttribute('height'));
    if (width > 0 && height > 0) heroImage.style.aspectRatio = `${width} / ${height}`;
    // Update both candidates synchronously. No image-load callback can restore an old color.
    if (media.srcset) heroImage.setAttribute('srcset', media.srcset);
    else heroImage.removeAttribute('srcset');
    heroImage.setAttribute('src', media.src);
    heroImage.setAttribute('alt', media.alt || '');
  };
  let purchasePending = false;
  let cartUnconfirmed = false;
  const applyQuantityRule = (box, option) => {
    if (!box || !option) return;
    const min = option.dataset.v3QuantityMin || '1';
    const max = option.dataset.v3QuantityMax || '';
    const step = option.dataset.v3QuantityStep || '1';
    box.querySelectorAll('[data-v3-quantity-input]').forEach((input) => {
      input.setAttribute('min', min);
      input.setAttribute('step', step);
      if (max) input.setAttribute('max', max);
      else input.removeAttribute('max');
    });
  };
  const syncVariant = (source) => {
    const id = String(source.value || source.dataset.variantId || '');
    if (!id || !variantSelects.some((select) => Array.from(select.options).some((option) => option.value === id))) return;

    variantSelects.forEach((select) => {
      if (select.value !== id) select.value = id;
    });

    variantChoices.forEach((choice) => {
      const selected = String(choice.dataset.variantId) === id;
      choice.classList.toggle('is-selected', selected);
      choice.setAttribute('aria-checked', selected ? 'true' : 'false');
      choice.dataset.selected = selected ? 'true' : 'false';
      choice.tabIndex = selected ? 0 : -1;
    });

    root.querySelectorAll('[data-v3-purchase]').forEach((box) => {
      const select = box.querySelector('[data-v3-variant-select]');
      const option = select.options[select.selectedIndex];
      const localChoice = Array.from(box.querySelectorAll('[data-variant-choice]'))
        .find((choice) => String(choice.dataset.variantId) === id);
      const title = (localChoice && localChoice.dataset.variantTitle)
        || (option && option.dataset.v3OptionTitle)
        || '';
      const optionPrice = (localChoice && localChoice.dataset.v3OptionPrice)
        || (option && option.dataset.v3OptionPrice)
        || '';
      const selectedLabel = box.querySelector('[data-selected-variant]');
      const price = box.querySelector('[data-v3-current-price]');

      box.dataset.selectedVariantId = id;
      applyQuantityRule(box, option);
      if (selectedLabel) selectedLabel.textContent = title;
      if (price && optionPrice) price.textContent = optionPrice;
      box.querySelectorAll('[data-add-button], [data-buy-now-button]').forEach((button) => {
        button.disabled = purchasePending || cartUnconfirmed || !option || option.disabled;
      });
    });

    syncHero(id);

    const firstQuantityInput = root.querySelector('[data-v3-quantity-input]');
    if (firstQuantityInput) syncQuantity(firstQuantityInput, { force: true });

    const variantUrl = new URL(window.location.href);
    variantUrl.searchParams.set('variant', id);
    window.history.replaceState(window.history.state, '', variantUrl.toString());
  };

  variantSelects.forEach((select) => {
    select.addEventListener('change', () => syncVariant(select));
  });

  variantChoices.forEach((choice) => {
    choice.addEventListener('click', () => syncVariant(choice));
    choice.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
      const group = choice.closest('[role="radiogroup"]');
      const choices = group
        ? Array.from(group.querySelectorAll('[data-variant-choice]:not(:disabled)'))
        : [];
      if (!choices.length) return;
      event.preventDefault();
      const currentIndex = Math.max(0, choices.indexOf(choice));
      let nextIndex = currentIndex;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = choices.length - 1;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + choices.length) % choices.length;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % choices.length;
      choices[nextIndex].focus();
      choices[nextIndex].click();
    });
  });
  const quantityInputs = Array.from(root.querySelectorAll('[data-v3-quantity-input]'));
  const quantityAttribute = (input, name, fallback) => {
    const raw = input.getAttribute(name);
    if (raw === null || raw === '' || (name === 'step' && raw === 'any')) return fallback;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : fallback;
  };
  const quantityPrecision = (...values) => Math.min(6, values.reduce((maximum, value) => {
    const raw = String(value);
    const decimal = raw.includes('.') ? raw.length - raw.indexOf('.') - 1 : 0;
    return Math.max(maximum, decimal);
  }, 0));
  const normalizeQuantity = (input, rawValue) => {
    const minimum = quantityAttribute(input, 'min', 1);
    const rawMaximum = quantityAttribute(input, 'max', Number.POSITIVE_INFINITY);
    const maximum = rawMaximum >= minimum ? rawMaximum : Number.POSITIVE_INFINITY;
    const rawStep = quantityAttribute(input, 'step', 1);
    const step = rawStep > 0 ? rawStep : 1;
    const numeric = Number.isFinite(rawValue) ? rawValue : minimum;
    const bounded = Math.min(maximum, Math.max(minimum, numeric));
    const stepped = minimum + Math.round((bounded - minimum) / step) * step;
    const clamped = Math.min(maximum, Math.max(minimum, stepped));
    return Number(clamped.toFixed(quantityPrecision(minimum, step, maximum)));
  };
  const updateQuantityControls = (input) => {
    const stepper = input.closest('[data-v3-quantity-stepper]');
    if (!stepper) return;
    const value = normalizeQuantity(input, Number(input.value));
    const minimum = quantityAttribute(input, 'min', 1);
    const maximum = quantityAttribute(input, 'max', Number.POSITIVE_INFINITY);
    const decrement = stepper.querySelector('[data-v3-quantity-decrement]');
    const increment = stepper.querySelector('[data-v3-quantity-increment]');
    if (decrement) decrement.disabled = value <= minimum;
    if (increment) increment.disabled = Number.isFinite(maximum) && value >= maximum;
  };
  const syncQuantity = (source, { force = false } = {}) => {
    const empty = source.value.trim() === '';
    const rawValue = Number(source.value);
    if ((empty || !Number.isFinite(rawValue)) && !force) {
      updateQuantityControls(source);
      return null;
    }
    const value = normalizeQuantity(source, rawValue);
    quantityInputs.forEach((input) => {
      input.value = String(normalizeQuantity(input, value));
      updateQuantityControls(input);
    });
    syncConfirmation();
    return value;
  };
  quantityInputs.forEach((input) => {
    input.addEventListener('input', () => syncQuantity(input));
    input.addEventListener('change', () => syncQuantity(input, { force: true }));
    input.addEventListener('blur', () => syncQuantity(input, { force: true }));
  });
  root.querySelectorAll('[data-v3-quantity-decrement], [data-v3-quantity-increment]').forEach((control) => {
    control.addEventListener('click', () => {
      const stepper = control.closest('[data-v3-quantity-stepper]');
      const input = stepper && stepper.querySelector('[data-v3-quantity-input]');
      if (!input) return;
      syncQuantity(input, { force: true });
      if (control.hasAttribute('data-v3-quantity-decrement')) input.stepDown();
      else input.stepUp();
      syncQuantity(input, { force: true });
      input.focus();
    });
  });
  const initialVariantId = new URL(window.location.href).searchParams.get('variant') || variantMedia.selected;
  const initialOption = variantSelects[0] && Array.from(variantSelects[0].options)
    .find((option) => option.value === String(initialVariantId));
  if (initialOption) variantSelects[0].value = initialOption.value;
  if (variantSelects[0]) syncVariant(variantSelects[0]);
  window.addEventListener('popstate', () => {
    const id = new URL(window.location.href).searchParams.get('variant') || variantMedia.selected;
    if (id) syncVariant({ value: id });
  });
  if (quantityInputs[0]) syncQuantity(quantityInputs[0], { force: true });

  const productForms = Array.from(root.querySelectorAll('.p10194551767337-product-form'));
  const routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const shopRoot = /^\/(?!\/)/.test(routeRoot) ? routeRoot.replace(/\/?$/, '/') : '/';
  const cartAddUrl = `${shopRoot}cart/add.js`;
  const checkoutUrl = `${shopRoot}checkout`;
  const purchaseButtons = Array.from(root.querySelectorAll('[data-add-button], [data-buy-now-button]'));
  const updatePurchaseButtons = () => {
    purchaseButtons.forEach((button) => {
      const select = button.closest('form').querySelector('[data-v3-variant-select]');
      const option = select && select.options[select.selectedIndex];
      button.disabled = purchasePending || cartUnconfirmed || !option || option.disabled;
    });
    syncConfirmation();
  };
  const cartSurface = () => {
    const component = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const horizon = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'));
    const sections = horizon.map((item) => item.dataset.sectionId);
    if (component && typeof component.getSectionsToRender === 'function') {
      try {
        sections.push(...component.getSectionsToRender().map((item) => item.section || item.id));
      } catch (_) { /* A theme adapter cannot prevent the actual cart request. */ }
    }
    if (document.getElementById('cart-icon-bubble')) sections.push('cart-icon-bubble');
    return { component, horizon: horizon.length > 0, sections: [...new Set(sections.filter(Boolean))].slice(0, 5) };
  };
  const linkCart = (status) => {
    if (!status) return;
    const link = document.createElement('a');
    link.href = `${shopRoot}cart`;
    link.textContent = 'View cart';
    status.append(' ', link);
  };
  const refreshCartSurface = async (surface, payload, variantId, quantity) => {
    // Rendering is separate from purchase success; it never issues a second add request.
    if (surface.component && typeof surface.component.renderContents === 'function') {
      if (!payload.sections || surface.sections.some((id) => typeof payload.sections[id] !== 'string')) {
        throw new Error('Cart sections are unavailable');
      }
      surface.component.classList.remove('is-empty');
      await surface.component.renderContents({ ...payload, id: payload.id || (payload.items && payload.items[0] && payload.items[0].id) });
    } else if (surface.horizon) {
      if (!payload.sections || surface.sections.some((id) => typeof payload.sections[id] !== 'string')) {
        throw new Error('Cart sections are unavailable');
      }
      root.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: {}, sourceId: String(variantId), data: {
          source: 'product-form-component', itemCount: quantity,
          productId: root.dataset.productId, sections: payload.sections,
        } },
      }));
    } else if (payload.sections && typeof payload.sections['cart-icon-bubble'] === 'string') {
      const bubble = document.getElementById('cart-icon-bubble');
      const parsed = new DOMParser().parseFromString(payload.sections['cart-icon-bubble'], 'text/html');
      const updated = parsed.querySelector('#cart-icon-bubble') || parsed.querySelector('.shopify-section');
      if (bubble && updated) bubble.innerHTML = updated.innerHTML;
    }
    root.dispatchEvent(new CustomEvent('v3:cart-added', { bubbles: true, detail: payload }));
  };
  const addFromForm = async (form, button, checkout = false) => {
    // One lock covers both actions in both purchase modules. Never clear the existing cart.
    if (purchasePending || cartUnconfirmed || !button || button.disabled) return;
    const status = button.hasAttribute('data-v3-sticky-add')
      ? root.querySelector('[data-v3-sticky-status]') : form.querySelector('[data-v3-cart-status]');
    const variant = form.querySelector('[data-v3-variant-select]');
    const quantityInput = form.querySelector('[data-v3-quantity-input]');
    const normalizedQuantity = quantityInput ? syncQuantity(quantityInput, { force: true }) : 1;
    const quantity = Number(normalizedQuantity) || 1;
    const option = variant && variant.options[variant.selectedIndex];
    if (!variant || !variant.value || !option || option.disabled) return;
    const variantId = Number(variant.value);
    if (!Number.isSafeInteger(variantId) || variantId <= 0 || !Number.isSafeInteger(quantity) || quantity <= 0) return;
    const originalLabel = button.textContent;
    let navigating = false;
    let addConfirmed = false;
    purchasePending = true;
    updatePurchaseButtons();
    button.setAttribute('aria-busy', 'true');
    if (status) {
      status.textContent = status.dataset.adding || '';
      if (status.dataset.adding) button.textContent = status.dataset.adding;
    }
    const surface = cartSurface();
    const requestBody = { items: [{ id: variantId, quantity }] };
    if (surface.sections.length) {
      requestBody.sections = surface.sections.join(',');
      const sectionUrl = new URL(window.location.href);
      requestBody.sections_url = sectionUrl.pathname + sectionUrl.search;
    }
    try {
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(requestBody),
      });
      let payload;
      try { payload = await response.json(); } catch (_) { cartUnconfirmed = true; }
      if (response.status === 429 || response.status >= 500) cartUnconfirmed = true;
      if (cartUnconfirmed || !payload || typeof payload !== 'object' || Array.isArray(payload)) {
        cartUnconfirmed = true;
        throw new Error('Your cart update could not be confirmed. Check your cart before adding again.');
      }
      if (!response.ok) throw new Error(payload.description || payload.message || `Cart request failed (${response.status})`);
      const addedItems = Array.isArray(payload.items) ? payload.items : [payload];
      const addedItem = addedItems[0];
      if (addedItems.length !== 1 || !addedItem || Number(addedItem.variant_id || addedItem.id) !== variantId
        || !Number.isSafeInteger(addedItem.quantity) || addedItem.quantity < quantity) {
        cartUnconfirmed = true;
        throw new Error('Your cart update could not be confirmed. Check your cart before adding again.');
      }
      addConfirmed = true;
      if (status) {
        status.textContent = status.dataset.added || '';
        if (status.dataset.added) button.textContent = status.dataset.added;
      }
      if (checkout) {
        navigating = true;
        button.textContent = 'Opening checkout…';
        window.location.assign(checkoutUrl);
      } else {
        try {
          await refreshCartSurface(surface, payload, variantId, quantity);
          root.dataset.v3CartRefresh = 'complete';
        } catch (_) {
          root.dataset.v3CartRefresh = 'unavailable';
          // The item is already added. Keep the success message and a usable cart link.
        }
        linkCart(status);
      }
    } catch (error) {
      navigating = false;
      if (!addConfirmed && error instanceof TypeError) cartUnconfirmed = true;
      if (status) status.textContent = addConfirmed
        ? (status.dataset.added || 'Added to your cart.')
        : cartUnconfirmed
          ? 'Your cart update could not be confirmed. Check your cart before adding again.'
          : (status.dataset.error || error.message);
      if (cartUnconfirmed || addConfirmed) linkCart(status);
      button.textContent = originalLabel;
    } finally {
      // Keep the lock until navigation; a second click must not add the item again.
      purchasePending = navigating;
      updatePurchaseButtons();
      button.removeAttribute('aria-busy');
      if (!navigating) button.textContent = originalLabel;
    }
  };
  productForms.forEach((form) => {
    const button = form.querySelector('[data-add-button]');
    const buyNowButton = form.querySelector('[data-buy-now-button]');
    if (button) button.addEventListener('click', (event) => { event.stopPropagation(); addFromForm(form, button); });
    if (buyNowButton) buyNowButton.addEventListener('click', (event) => { event.stopPropagation(); addFromForm(form, buyNowButton, true); });
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      addFromForm(form, event.submitter === buyNowButton ? buyNowButton : button, event.submitter === buyNowButton);
    }, true);
  });
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    purchasePending = false;
    purchaseButtons.forEach((button) => {
      if (button.hasAttribute('data-buy-now-button')) button.textContent = 'Buy now';
      button.removeAttribute('aria-busy');
    });
    updatePurchaseButtons();
  });

  const firstPurchase = root.querySelector('[data-v3-section="1"] [data-v3-purchase]');
  const secondPurchase = root.querySelector('[data-v3-section="5"] [data-v3-purchase]');
  const purchaseTarget = secondPurchase || firstPurchase;
  const finalSection = root.querySelector('[data-v3-section="7"]');
  const finalAction = root.querySelector('[data-v3-final-cta]');
  const sticky = root.querySelector('.p10194551767337-sticky-cta[data-v3-sticky-cta]');
  const intersectsViewport = (box) => Boolean(box && box.top < window.innerHeight && box.bottom > 0);
  const updateStickyFromLayout = () => {
    if (!sticky) return;
    const firstBox = firstPurchase && firstPurchase.getBoundingClientRect();
    const secondBox = secondPurchase && secondPurchase.getBoundingClientRect();
    const finalBox = finalSection && finalSection.getBoundingClientRect();
    const visible = Boolean(firstBox && firstBox.bottom <= 0)
      && !intersectsViewport(secondBox)
      && !intersectsViewport(finalBox);
    sticky.classList.toggle('is-visible', visible);
    sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
  };
  if (sticky) {
    let stickyFrame = 0;
    const scheduleStickyUpdate = () => {
      if (stickyFrame) return;
      stickyFrame = window.requestAnimationFrame(() => {
        stickyFrame = 0;
        updateStickyFromLayout();
      });
    };
    window.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
    window.addEventListener('resize', scheduleStickyUpdate);
    window.addEventListener('pageshow', scheduleStickyUpdate);
    window.addEventListener('load', scheduleStickyUpdate, { once: true });
    updateStickyFromLayout();
  }

  const focusPurchase = () => {
    if (!purchaseTarget) return;
    purchaseTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const panel = purchaseTarget.querySelector('[data-v3-choice-panel]');
    const control = visualCards && panel?.hidden
      ? purchaseTarget.querySelector('[data-v3-change-style]')
      : purchaseTarget.querySelector('[data-variant-choice][aria-checked="true"], [data-v3-variant-select]:not([aria-hidden="true"]), [data-v3-primary-cta]');
    if (control) window.setTimeout(() => control.focus({ preventScroll: true }), 350);
  };
  const stickyAction = sticky && sticky.querySelector('[data-v3-sticky-action]');
  if (stickyAction) stickyAction.addEventListener('click', (event) => {
    if (visualCards) {
      event.stopPropagation();
      if (productForms[0]) addFromForm(productForms[0], stickyAction);
    } else focusPurchase();
  });
  if (finalAction) finalAction.addEventListener('click', focusPurchase);

  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const motionVideos = Array.from(root.querySelectorAll('video[data-v3-motion]'));
  const motionStates = motionVideos.map((video) => ({
    video,
    item: video.closest('[data-v3-media-item]') || video.parentElement,
    button: (video.closest('[data-v3-media-item]') || video.parentElement).querySelector('[data-v3-motion-toggle]'),
    visible: false,
    loaded: false,
    userPaused: false,
    blocked: false,
    playing: false,
    playPending: false,
  }));
  const updateMotionControl = (state) => {
    if (!state.button) return;
    const label = state.playing ? 'Pause video' : 'Play video';
    state.button.textContent = label;
    state.button.setAttribute('aria-label', label);
    state.button.setAttribute('aria-pressed', state.playing ? 'true' : 'false');
    state.button.hidden = motionQuery.matches;
  };
  const pauseMotion = (state) => {
    state.video.pause();
    state.playing = false;
    updateMotionControl(state);
  };
  const staticMotion = (state, enabled) => {
    state.item.classList.toggle('is-motion-static', enabled);
  };
  const loadMotion = (state) => {
    if (state.loaded || motionQuery.matches) return;
    state.video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
    });
    state.loaded = true;
    state.video.load();
  };
  const playMotion = (state, manual = false) => {
    if (motionQuery.matches || document.hidden || !state.visible || state.playPending) return;
    if (!manual && (state.userPaused || state.blocked || !state.video.hasAttribute('data-v3-autoplay'))) return;
    loadMotion(state);
    staticMotion(state, false);
    state.playPending = true;
    Promise.resolve(state.video.play()).then(() => {
      if (!state.visible || document.hidden || motionQuery.matches || state.userPaused) {
        pauseMotion(state);
        return;
      }
      state.playing = true;
      state.blocked = false;
      updateMotionControl(state);
    }).catch(() => {
      state.blocked = true;
      pauseMotion(state);
      staticMotion(state, true);
    }).finally(() => { state.playPending = false; });
  };
  motionStates.forEach((state) => {
    state.video.muted = true;
    state.video.loop = true;
    state.video.playsInline = true;
    // The observer owns playback; an HTML autoplay attribute would download too early.
    state.video.removeAttribute('autoplay');
    state.video.addEventListener('error', () => {
      state.blocked = true;
      pauseMotion(state);
      staticMotion(state, true);
    });
    if (state.button) state.button.addEventListener('click', () => {
      if (state.playing || state.playPending) {
        state.userPaused = true;
        pauseMotion(state);
      } else {
        state.userPaused = false;
        state.blocked = false;
        // A failed resource may be retried only after an explicit play action.
        if (state.video.error) state.loaded = false;
        const bounds = state.video.getBoundingClientRect();
        const itemBounds = state.item.getBoundingClientRect();
        state.visible = intersectsViewport(bounds) || intersectsViewport(itemBounds);
        playMotion(state, true);
      }
    });
    updateMotionControl(state);
  });
  const updateMotionFromLayout = () => {
    motionStates.forEach((state) => {
      const bounds = state.item.getBoundingClientRect();
      staticMotion(state, motionQuery.matches || state.blocked);
      state.visible = intersectsViewport(state.video.getBoundingClientRect());
      if (!motionQuery.matches && bounds.top < window.innerHeight + 200 && bounds.bottom > -200) loadMotion(state);
      if (!state.visible || document.hidden || motionQuery.matches) pauseMotion(state);
      else playMotion(state);
      updateMotionControl(state);
    });
  };
  const applyMotionPreference = () => updateMotionFromLayout();
  if (typeof motionQuery.addEventListener === 'function') {
    motionQuery.addEventListener('change', applyMotionPreference);
  } else if (typeof motionQuery.addListener === 'function') {
    motionQuery.addListener(applyMotionPreference);
  }

  if ('IntersectionObserver' in window && motionStates.length) {
    const stateFor = (target) => motionStates.find((state) => state.item === target || state.video === target);
    const loadObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const state = stateFor(entry.target);
        if (state && entry.isIntersecting) loadMotion(state);
      });
    }, { rootMargin: '200px 0px', threshold: 0 });
    const playObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const state = stateFor(entry.target);
        if (!state) return;
        state.visible = entry.isIntersecting && entry.intersectionRatio > 0;
        if (state.visible) playMotion(state);
        else pauseMotion(state);
      });
    }, { rootMargin: '0px', threshold: [0, .05] });
    motionStates.forEach((state) => {
      loadObserver.observe(state.item);
      playObserver.observe(state.video);
    });
  } else if (motionStates.length) {
    let motionFrame = 0;
    window.addEventListener('scroll', () => {
      if (motionFrame) return;
      motionFrame = window.requestAnimationFrame(() => {
        motionFrame = 0;
        updateMotionFromLayout();
      });
    }, { passive: true });
  }
  if (motionStates.length) {
    window.addEventListener('resize', updateMotionFromLayout);
    document.addEventListener('visibilitychange', updateMotionFromLayout);
    applyMotionPreference();
  }

  // Only source dates marked by the compiler are relative; missing dates remain unchanged.
  let relativeTime;
  try { relativeTime = new Intl.RelativeTimeFormat(document.documentElement.lang || 'en', { numeric: 'auto' }); }
  catch (_) { relativeTime = new Intl.RelativeTimeFormat('en', { numeric: 'auto' }); }
  const calendarDay = (date) => Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / 86400000;
  const today = calendarDay(new Date());
  root.querySelectorAll('time[data-v3-review-date][datetime]').forEach((node) => {
    const raw = node.getAttribute('datetime');
    const dayOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw);
    const date = dayOnly ? new Date(Number(dayOnly[1]), Number(dayOnly[2]) - 1, Number(dayOnly[3])) : new Date(raw);
    if (!Number.isFinite(date.getTime())) return;
    if (dayOnly && (date.getFullYear() !== Number(dayOnly[1]) || date.getMonth() + 1 !== Number(dayOnly[2]) || date.getDate() !== Number(dayOnly[3]))) return;
    const days = calendarDay(date) - today;
    const absolute = Math.abs(days);
    const [divisor, unit] = absolute < 7 ? [1, 'day'] : absolute < 30 ? [7, 'week'] : absolute < 365 ? [30, 'month'] : [365, 'year'];
    node.textContent = relativeTime.format(Math.trunc(days / divisor), unit);
    node.title = raw;
  });

  let photoDialog;
  root.querySelectorAll('[data-v3-review-photo]').forEach((button) => {
    button.addEventListener('click', () => {
      const thumbnail = button.querySelector('img');
      const src = button.dataset.v3PhotoSrc || (thumbnail && thumbnail.currentSrc);
      if (!src) return;
      if (!photoDialog) {
        photoDialog = document.createElement('dialog');
        photoDialog.className = 'p10194551767337-photo-dialog';
        photoDialog.setAttribute('aria-label', 'Buyer photo');
        const closeButton = document.createElement('button');
        closeButton.type = 'button';
        closeButton.textContent = 'Close photo';
        closeButton.addEventListener('click', () => photoDialog.close());
        photoDialog.append(closeButton, document.createElement('img'));
        photoDialog.addEventListener('click', (event) => {
          if (event.target !== photoDialog) return;
          const bounds = photoDialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) photoDialog.close();
        });
        root.append(photoDialog);
      }
      const image = photoDialog.querySelector('img');
      image.src = src;
      image.alt = (thumbnail && thumbnail.alt) || 'Buyer photo';
      photoDialog.showModal();
    });
  });
})();
